import React, { memo, useCallback } from "react";
import { DatoKeyValuesMap } from "../data/datoContentData";
import { Wrapper, Container, HeroImage } from "../styles/components/section";
import Component from "./component";

const Section = memo(({ datoContentData, heroImage }) => {
  const findComponentByKey = useCallback(key => {
    const section = DatoKeyValuesMap.find(section => section.key === key);
    if (!section) {
      console.error(`Component with key "${key}" not found.`);
      return null;
    }
    return section.component;
  }, []);

  return (
    <Wrapper>
      {heroImage && (
        <HeroImage
          src={heroImage.fluid.src}
          srcSet={heroImage.fluid.srcSet}
          alt="Hero Image"
        />
      )}
      {datoContentData?.map(contentItem => {
        const SectionComponent = contentItem.key
          ? findComponentByKey(contentItem.key)
          : contentItem;

        if (!SectionComponent) return null;

        return (
          <Container
            key={contentItem.id}
            className={contentItem.key || contentItem.id}
          >
            {contentItem.key ? (
              <SectionComponent {...contentItem.content} />
            ) : (
              <Component {...contentItem} />
            )}
          </Container>
        );
      })}
    </Wrapper>
  );
});

export default Section;
